import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import apiClient from "../api/client";
import { useDistanceUnit } from "../contexts/DistanceUnitContext";
import ActivityTable from "./ActivityTable";
import { parseActivityDate } from "../utils/dateUtils";

const CurrentStreak = () => {
  const [streakData, setStreakData] = useState(null);
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const { unit } = useDistanceUnit();

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch streak data
        const streakResponse = await apiClient.get('/activities/runstreak');
        setStreakData(streakResponse.data);

        // Fetch activities
        const activitiesResponse = await apiClient.get('/activities');

        // Filter activities for current streak period
        if (streakResponse.data.current_streak_start && streakResponse.data.current_streak_end) {
          const startDate = new Date(streakResponse.data.current_streak_start);
          const endDate = new Date(streakResponse.data.current_streak_end);
          endDate.setHours(23, 59, 59, 999); // Include entire end day

          const streakActivities = activitiesResponse.data.activities.filter(activity => {
            const activityDate = parseActivityDate(activity);
            return activityDate && activityDate >= startDate && activityDate <= endDate;
          });

          setActivities(streakActivities);
        }

        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div className="container"><div className="card"><p>Loading...</p></div></div>;
  }

  if (!streakData || !streakData.is_active) {
    return (
      <div className="container">
        <div className="card">
          <h1>🔥 Current Streak</h1>
          <p>You don't have an active streak. Run at least 1 mile today to start a new streak!</p>
          <Link to="/dashboard">← Back to Dashboard</Link>
        </div>
      </div>
    );
  }

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    return new Date(dateStr).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' });
  };

  const convertMilesToUnit = (miles) => {
    if (!miles) return 0;
    if (unit === 'km') {
      return (miles * 1.60934).toFixed(2);
    }
    return miles;
  };

  return (
    <div className="container">
      <div className="card">
        <Link to="/dashboard" style={{ textDecoration: 'none', color: '#14b8a6', marginBottom: '20px', display: 'inline-block' }}>
          ← Back to Dashboard
        </Link>
        <h1>🔥 Current Streak</h1>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', margin: '20px 0' }}>
          <div style={{ textAlign: 'center', padding: '20px', background: '#f0fdfa', borderRadius: '12px' }}>
            <h3 style={{ color: '#14b8a6', fontSize: '48px', margin: '0' }}>{streakData.current_streak}</h3>
            <p style={{ color: '#6b7280', margin: '8px 0' }}>Days</p>
          </div>
          <div style={{ textAlign: 'center', padding: '20px', background: '#f0fdfa', borderRadius: '12px' }}>
            <h3 style={{ color: '#14b8a6', fontSize: '48px', margin: '0' }}>{convertMilesToUnit(streakData.current_streak_distance)}</h3>
            <p style={{ color: '#6b7280', margin: '8px 0' }}>{unit === 'km' ? 'Kilometers' : 'Miles'}</p>
          </div>
        </div>

        <div style={{ margin: '20px 0', padding: '20px', background: '#f9fafb', borderRadius: '12px' }}>
          <h3>Streak Period</h3>
          <p>📅 {formatDate(streakData.current_streak_start)} - {formatDate(streakData.current_streak_end)}</p>
          <p style={{ color: '#14b8a6', fontWeight: '600', marginTop: '12px' }}>🎉 Active Streak! Keep it going!</p>
        </div>
      </div>

      <div className="card">
        <h2>Activities in Current Streak ({activities.length})</h2>
        <ActivityTable activities={activities} showDateFilter={false} />
      </div>
    </div>
  );
};

export default CurrentStreak;
